import { FaInstagram, FaIndustry } from "react-icons/fa6";
import { IoCallOutline, IoLocationSharp, IoTime, IoMailOutline, IoGlobeOutline } from "react-icons/io5";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

const Footer = () => {
  return (
    <footer
      className="relative bg-[#0B1E2B] text-white w-full h-auto px-6 py-10 leading-8"
      style={{
        backgroundImage: "url('/media/footer.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for darkening the image */}
      <div className="absolute inset-0 bg-[#0B1E2B]/80 pointer-events-none" />
      <div className="relative z-10 max-w-[1440px] mx-auto">
        {/* Certification Images - at top of footer */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 pb-6 mb-6 border-b border-gray-700">
          <img src="/media/fssai.webp" alt="FSSAI Certified" className="h-12 object-contain rounded-lg" />
          <img src="/media/haccp.webp" alt="HACCP Certified" className="h-12 object-contain rounded-lg" />
          <img src="/media/gmp-certified.avif" alt="GMP Certified" className="h-12 object-contain rounded-lg" />
          <img src="/media/apeda-cert.png" alt="APEDA Certified" className="h-12 object-contain rounded-lg" />
          <img src="/media/iso.webp" alt="ISO Certified" className="h-12 object-contain rounded-lg" />
          <img src={encodeURI("/media/iso 9001.png")} alt="ISO 9001:2015 Certified" className="h-12 object-contain rounded-lg" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 text-lg">
          {/* Column 1 - Brand Info */}
          <div className="space-y-4 text-left justify-start">
            <h2 className="text-4xl font-bold text-orange-500">Zenvia Foods Private Limited</h2>
            <p className="mt-1 text-md text-gray-400">
              From Farm to Fork, With Care
            </p>
            <p className="mt-2 text-sm text-gray-500">
              Leading manufacturer of premium fruit pulps and frozen products for global markets
            </p>
            <div className="mt-4 space-y-2 text-gray-400">
              <p className="flex items-center gap-2 text-base">
                <HiOutlineOfficeBuilding size={18} style={{ color: "var(--primary)" }} />
                Zenvia Foods Private Limited
              </p>
              <div className="space-y-1">
                <p className="flex items-center gap-2 text-base">
                  <IoCallOutline size={18} style={{ color: "var(--primary)" }} />
                  +91 88850 66991
                </p>
              </div>
              <div className="space-y-1">
                <p className="flex items-center gap-2 text-base">
                  <IoMailOutline size={18} style={{ color: "var(--primary)" }} />
                  rajesh@zenviafood.com
                </p>
              </div>
              <div className="flex items-start gap-2 text-base">
                <IoLocationSharp size={18} style={{ color: "var(--primary)" }} className="mt-1" />
                <div className="space-y-3">
                  <div>
                    <span className="text-gray-300 font-medium flex items-center gap-1.5 mb-0.5">
                      <HiOutlineOfficeBuilding size={16} style={{ color: "var(--primary)" }} />
                      Office
                    </span>
                    <address className="not-italic text-gray-400 leading-6 max-w-xs break-words">
                      Plot 121, 1st floor, Road 3<br/>
                      Kakateeyahills, Madhapur<br/>
                      Hyderabad, 500081, TG
                    </address>
                  </div>
                  <div>
                    <span className="text-gray-300 font-medium flex items-center gap-1.5 mb-0.5">
                      <FaIndustry size={16} style={{ color: "var(--primary)" }} />
                      Plant
                    </span>
                    <address className="not-italic text-gray-400 leading-6 max-w-xs break-words">
                      Zenvia Foods Private Limited<br/>
                      284/11/8C, Bhavathi Amman Kovil Street<br/>
                      Surulipatti, Cumbum, Tamil Nadu - 625516
                    </address>
                  </div>
                </div>
              </div>
              <div className="space-y-1">
                <p className="flex items-center gap-2 text-base">
                  <IoGlobeOutline size={18} style={{ color: "var(--primary)" }} />
                  www.zenviafood.com
                </p>
              </div>
              <p className="flex items-center gap-2 text-base">
                <IoTime size={18} style={{ color: "var(--primary)" }} />
                Mon-Sat: 9:00 AM - 6:00 PM
              </p>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/">Home</a></li>
              <li><a href="/products">All Products</a></li>
              <li><a href="/applications">Applications</a></li>
              <li><a href="/sustainability">Sustainability</a></li>
              {/* <li><a href="/brochure">Brochure</a></li> */}
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/contact-us">Contact Us</a></li>
            </ul>
          </div>

          {/* Column 3 - Products */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Our Products</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Mango Pulp (Totapuri, Alphonso, Kesar)</li>
              <li>Guava & Pineapple Pulp</li>
              <li>Mixed Fruit Pulps</li>
              <li>IQF Frozen Fruits</li>
              <li>Frozen Vegetables</li>
              <li>Custom Blends</li>
            </ul>
          </div>

          {/* Column 4 - Social */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Connect With Us</h3>
            <div className="flex space-x-4 text-xl text-gray-400 mb-4 items-center">
              <a href="https://instagram.com/zenviafoods" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                <FaInstagram className="hover:text-white cursor-pointer" />
                <span className="text-base text-gray-400 hover:text-white">@zenviafoods</span>
              </a>
            </div>
            {/* Certifications Section */}
            {/* <div className="mt-6">
              <h4 className="text-md font-semibold text-white mb-2">Certifications</h4>
              <div className="flex items-center space-x-4">
                <img src="/media/fssai.webp" alt="FSSAI Certified" className="h-16 w-auto object-contain rounded-lg" />
                <img src="/media/iso.webp" alt="ISO Certified" className="h-16 w-auto object-contain rounded-lg" />
                <img src="/media/haccp.webp" alt="HACCP Certified" className="h-16 w-auto object-contain rounded-lg" />
              </div>
            </div> */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 border-t border-gray-700 pt-4 text-center text-base text-gray-400">
          © {new Date().getFullYear()} Zenvia Foods Private Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
